import React, { useState } from 'react';
import {
    RightOutlined,
    CodeOutlined,
    MobileOutlined,
    GlobalOutlined,
    TeamOutlined,
    ThunderboltOutlined,
    HeartOutlined,
    TruckOutlined,
    DollarOutlined,
    DesktopOutlined,
    ReadOutlined,
    ShoppingCartOutlined,
    DropboxOutlined
} from '@ant-design/icons';
import { Card, Row, Col, Divider, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

const Services = () => {
    const [hoveredItem, setHoveredItem] = useState(null);

    const navigate = useNavigate();

    const softwareServices = [
        { icon: <CodeOutlined style={{ fontSize: '40px' }} />, title: 'Software Product Development', desc: 'End-to-end custom software solutions' , to_url: '/software-development'},
        { icon: <ThunderboltOutlined style={{ fontSize: '40px' }} />, title: 'Digital Marketing', desc: 'SEO, PPC, Content Marketing solutions' , to_url: '/digital-marketing'},
        { icon: <GlobalOutlined style={{ fontSize: '40px' }} />, title: 'Web Development', desc: 'Modern, responsive web applications' , to_url: '/web-development'},
        { icon: <MobileOutlined style={{ fontSize: '40px' }} />, title: 'Mobile App Development', desc: 'iOS and Android applications' , to_url: '/mobile-app-development'},
         { icon: <ShoppingCartOutlined style={{ fontSize: '40px' }} />, title: 'eCommerce', desc: 'eCommerce Pros, Anytime You Need', to_url: '/eCommerce-development' },
        { icon: <TeamOutlined style={{ fontSize: '40px' }} />, title: 'IT Staff Outsourcing', desc: 'Skilled technical talent on demand', to_url: '/out-sourcing' }
    ];

    const industryServices = [
        { icon: <HeartOutlined style={{ fontSize: '40px' }} />, title: 'Healthcare Software', desc: 'HIPAA-compliant medical solutions', to_url: '/services' },
        { icon: <TruckOutlined style={{ fontSize: '40px' }} />, title: 'Logistics Software', desc: 'Supply chain and fleet management' , to_url: '/services'},
        { icon: <DollarOutlined style={{ fontSize: '40px' }} />, title: 'FinTech Software', desc: 'Financial technology solutions', to_url: '/services' },
        { icon: <DesktopOutlined style={{ fontSize: '40px' }} />, title: 'AdTech Software', desc: 'Advertising and marketing platforms', to_url: '/services' },
        { icon: <DropboxOutlined style={{ fontSize: '40px' }} />, title: 'MVP Software', desc: 'Core features, fast to market', to_url: '/services' },
        { icon: <ReadOutlined style={{ fontSize: '40px' }} />, title: 'EdTech Software', desc: 'Educational technology platforms', to_url: '/services' }
    ];

    const ServiceItem = ({ service, index, category }) => {
        const itemKey = `${category}-${index}`;
        const isHovered = hoveredItem === itemKey;

        return (
            <Col span={24}>
                <Card
                    hoverable
                    className={`mb-3 ${isHovered ? 'border-blue-500' : ''}`}
                    onMouseEnter={() => setHoveredItem(itemKey)}
                    onMouseLeave={() => setHoveredItem(null)}
                    bodyStyle={{ padding: '16px' }}
                    onClick={()=> navigate(`${service.to_url}`)}

                >
                    <Row align="middle" gutter={12}>
                        <Col>
                            <div
                                className={`p-2 rounded-lg ${isHovered
                                        ? 'bg-blue-500 text-white'
                                        : 'bg-gray-100 text-gray-600'
                                    }`}
                            >
                                {service.icon}
                            </div>
                        </Col>
                        <Col flex="auto">
                            <Text strong className={isHovered ? 'text-blue-500' : ''}>
                                {service.title}
                            </Text>
                            <Paragraph type="secondary" className="mb-0" style={{ fontSize: '12px' }}>
                                {service.desc}
                            </Paragraph>
                        </Col>
                        <Col>
                            <RightOutlined className={isHovered ? 'text-blue-500' : 'text-gray-400'} />
                        </Col>
                    </Row>
                </Card>
            </Col>
        );
    };

    return (
        <div>

            <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                    <Title level={4} style={{ color: '#04b3fe' }} >Software Services</Title>
                    <Divider className="bg-blue-500 h-1 w-20" />
                    <Row gutter={[0, 8]}>
                        {softwareServices.map((service, index) => (
                            <ServiceItem
                                key={index}
                                service={service}
                                index={index}
                                category="software"
                            />
                        ))}
                    </Row>
                </Col>

                <Col xs={24} md={12}>
                    <Title level={4} style={{ color: '#04b3fe' }}>Industry Specific Solutions</Title>
                    <Divider className="bg-purple-500 h-1 w-20" />
                    <Row gutter={[0, 8]}>
                        {industryServices.map((service, index) => (
                            <ServiceItem
                                key={index}
                                service={service}
                                index={index}
                                category="industry"
                            />
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default Services;